module.exports = __webpack_public_path__ + "img/Info.0d239a05.svg";